import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { ProcessTaskDefinitionEntity } from './process-task-definition.entity';
import { ProcessTaskEntity } from './process-task.entity';

@Index(
	'process_task_history__fk_process_task_definition__id_fk',
	['fkProcessTaskDefinitionId'],
	{},
)
@Entity('process_task_history')
export class ProcessTaskHistoryEntity extends BaseEntity {
	@Column('int', { name: '_fk_process_task_definition__id', unsigned: true })
	public fkProcessTaskDefinitionId!: number;

	@Column('int', { name: 'object__id' })
	public objectId!: number;

	@Column('int', { name: 'object_record__id' })
	public objectRecordId!: number;

	@Column('varchar', { name: 'status', length: 255 })
	public status!: string;

	@Column('varchar', { name: 'previousStatus', nullable: true, length: 255 })
	public previousStatus!: string | null;

	@OneToMany(
		() => ProcessTaskEntity,
		(processTask) => processTask.fkProcessTaskHistory,
		{},
	)
	public processTasks!: Array<ProcessTaskEntity>;

	@ManyToOne(
		() => ProcessTaskDefinitionEntity,
		(processTaskDefinition) => processTaskDefinition.processTaskHistories,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: '_fk_process_task_definition__id', referencedColumnName: 'id' },
	])
	public fkProcessTaskDefinition!: ProcessTaskDefinitionEntity;
}
